<div class="title">{{ "measurement.title" | translate }}</div>

<a class="change-unit" (click)="changeUnitSystem()">
  <span>{{ "measurement.changeUnit" | translate }}</span>
  <span>&nbsp;</span>
  {{ "measurement." + getChangeUnitLabel() | translate }}
</a>
<div class="results">
  @for (measure of measurements(); track $index) {
    @let selectedMeasurement = selectedMeasurement$();
    @let isSelected = selectedMeasurement?.measureId === measure.measureId;
    @let results = getResults(measure);

    <div class="measure" [class.selected]="isSelected" (click)="selectMeasurement(measure)">
      <div class="measure-info">
        <span class="label">{{ "measurement." + measure.type | translate }}:</span>
        @if (results.length === 1) {
          <div class="value">
            {{ results[0].value | convert: unitSystem() : results[0].unitType | number: precision }}
            <span class="unit">{{ getUnitLabel(results[0].unitType) }}</span>
          </div>
        }
      </div>
      @if (isSelected) {
        <evc-button [textContent]="'remove'" [importance]="'secondary'" size="small" (click)="removeMeasure(measure)"></evc-button>
      }
    </div>

    @if (results.length > 1) {
      <div class="measure-items" (click)="selectMeasurement(measure)">
        @for (item of results; track $index) {
          <div class="measure-item" [class.selected]="isSelected && !!item.pointId && item.pointId === selectedPointId()">
            <span class="label">{{ item.label | translate: item.labelParams }}:</span>
            <div class="value">
              {{ item.value | convert: unitSystem() : item.unitType | number: precision }}
              <span class="unit">{{ getUnitLabel(item.unitType) }}</span>
            </div>
          </div>
        }
      </div>
    }
  }
</div>
